// ** Product Api
import showLoader from '@components/loader';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../@core/components/skelton/store';
// Lead Report
export const getLeadReport = createAsyncThunk('reportSlice/getLeadReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/lead', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

//Employee Report
export const getEmployeeReport = createAsyncThunk('reportSlice/getEmployeeReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/employee-report', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Call Report
export const getCallsReport = createAsyncThunk('reportSlice/getCallsReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/call', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
// Meetings Report
export const getMeetingsReport = createAsyncThunk('reportSlice/getMeetingsReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/meeting', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getContactReport = createAsyncThunk('reportSlice/getContactReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/contact', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getDealReport = createAsyncThunk('reportSlice/getDealReport', async (data) => {
    try {
        let response = await axios.post('/reports/deal', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getCustomerReport = createAsyncThunk('reportSlice/getCustomerReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/account', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getToDosReport = createAsyncThunk('reportSlice/getToDosReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/todo', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getConversionReport = createAsyncThunk('reportSlice/getConversionReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/lead-conversation-report', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
// Lead Count Report
export const getLeadCountReport = createAsyncThunk('reportSlice/getLeadCountReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/lead-count-source-date', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data?.resultData);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLeadRevenueReport = createAsyncThunk('reportSlice/getLeadRevenueReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/lead-revenue-report', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data?.resultData);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getTeamMember = createAsyncThunk('reportSlice/getTeamMember', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/salesTeamMemberByIds', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLeadCountStatusReport = createAsyncThunk('reportSlice/getLeadCountStatusReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/reports/lead-count-status-source', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

//comapare report api sending date and getting count for comparing
export const getCompareReport = createAsyncThunk('reportSlice/getCompareReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        const response = await axios.post('reports/compare-report', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.error('Error fetching compare report:', err);
        return Promise.reject(err);
    }
});

//Login Log Report
export const postLoginLogReport = createAsyncThunk('reportSlice/postLoginLogReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        const response = await axios.post('/reports/login-log', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.error('Error fetching Login Log report:', err);
        return Promise.reject(err);
    }
});

//Activity Log Report
export const postActivityLogReport = createAsyncThunk('reportSlice/postActivityLogReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        const response = await axios.post('/reports/action-log', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.error('Error fetching Activity Log report:', err);
        return Promise.reject(err);
    }
});
//Third Party Report
export const postThirdPartyLogReport = createAsyncThunk('reportSlice/postThirdPartyLogReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        const response = await axios.post('/third-party-logs ', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.error('Error fetching Activity Log report:', err);
        return Promise.reject(err);
    }
});
//Call log Report
export const postCallLogReport = createAsyncThunk('reportSlice/postCallLogReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        const response = await axios.post('/call-logs', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.error('Error fetching Activity Log report:', err);
        return Promise.reject(err);
    }
});
export const getLeadPerformanceReport = createAsyncThunk('reportSlice/getLeadPerformanceReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('reports/lead-performance-report', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const customReportBuilder = createAsyncThunk('reportSlice/customReportBuilder', async (data, { _, dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post('/report-builder', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createReportBuilder = createAsyncThunk('reportSlice/createReportBuilder', async (data, { _, dispatch }) => {
    try {
        const response = await axios.post('/create-report', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        toast.success(response?.data?.message || 'Report  Created successfully.');
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.error('Error fetching Activity Log report:', err);
        return Promise.reject(err);
    }
});
export const updateReportBuilder = createAsyncThunk('reportSlice/updateReportBuilder', async (data, { _, dispatch }) => {
    try {
        const response = await axios.put('/report-builder/' + data?.id, data?.data, {
            headers: { 'Content-Type': 'application/json' }
        });
        toast.success(response?.data?.message || 'Report  Update successfully.');
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getCustomReport = createAsyncThunk('reportSlice/getCustomReport', async (data, { _, dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/report-builder/all', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getCustomReportById = createAsyncThunk('reportSlice/getCustomReportById', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/report-builder/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteCustomReport = createAsyncThunk('reportSlice/deleteCustomReport', async (data, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.delete('/report-builder/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        toast.success(response?.data?.message || 'Report  deleted successfully.');
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getReportDetails = createAsyncThunk('reportSlice/getReportDetails', async ({ payload }, { _, dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post(`/reports/${payload.url}`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getMassImportLog = createAsyncThunk('reportSlice/getMassImportLog', async (data, { _, dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.post('/log-bulk-import-list', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const reportSlice = createSlice({
    name: 'reportSlice',
    initialState: {
        lead: [],
        employeeReport: [],
        contact: [],
        calls: [],
        conversion: [],
        deal: [],
        meetings: [],
        customer: [],
        toDos: [],
        compareReport: [],
        loginLogReport: [],
        activityLogReport: [],
        thirdPartyLogReport: [],
        leadCountReport: [],
        teamMember: [],
        leadRevenueReport: [],
        leadCountStatus: [],
        callLogReport: [],
        customReport: [],
        reportBuilder: [],
        editReport: {},
        leadPerformanceReport: [],
        reportDetails: [],
        massImportLog: []
    },
    reducers: {
        removeEmployeeLead: (state, action) => {
            state.employeeReport = [];
        },
        removeReport: (state, action) => {
            state.editReport = {};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getLeadReport.fulfilled, (state, action) => {
            state.lead = action.payload;
            return;
        });
        builder.addCase(getEmployeeReport.fulfilled, (state, action) => {
            state.employeeReport = action.payload;
            return;
        });
        builder.addCase(getContactReport.fulfilled, (state, action) => {
            state.contact = action.payload;
            return;
        });
        builder.addCase(getCallsReport.fulfilled, (state, action) => {
            state.calls = action.payload;
            return;
        });
        builder.addCase(getDealReport.fulfilled, (state, action) => {
            state.deal = action.payload;
            return;
        });
        builder.addCase(getMeetingsReport.fulfilled, (state, action) => {
            state.meetings = action.payload;
        });
        builder.addCase(getCustomerReport.fulfilled, (state, action) => {
            state.customer = action.payload;
            return;
        });
        builder.addCase(getToDosReport.fulfilled, (state, action) => {
            state.toDos = action.payload;
            return;
        });
        builder.addCase(getConversionReport.fulfilled, (state, action) => {
            state.conversion = action.payload;
            return;
        });
        builder.addCase(getLeadCountStatusReport.fulfilled, (state, action) => {
            state.leadCountStatus = action.payload.resultData;
            return;
        });
        builder.addCase(getLeadCountReport.fulfilled, (state, action) => {
            state.leadCountReport = action.payload;
            return;
        });
        builder.addCase(getLeadRevenueReport.fulfilled, (state, action) => {
            state.leadRevenueReport = action.payload;
            return;
        });
        builder.addCase(getTeamMember.fulfilled, (state, action) => {
            state.teamMember = action.payload;
            return;
        });
        builder.addCase(getCompareReport.fulfilled, (state, action) => {
            state.compareReport = action.payload || [];
            return;
        });
        builder.addCase(postLoginLogReport.fulfilled, (state, action) => {
            state.loginLogReport = action.payload || [];
            return;
        });
        builder.addCase(postActivityLogReport.fulfilled, (state, action) => {
            state.activityLogReport = action.payload || [];
            return;
        });
        builder.addCase(postThirdPartyLogReport.fulfilled, (state, action) => {
            state.thirdPartyLogReport = action.payload || [];
            return;
        });
        builder.addCase(postCallLogReport.fulfilled, (state, action) => {
            state.callLogReport = action.payload || [];
            return;
        });
        builder.addCase(customReportBuilder.fulfilled, (state, action) => {
            state.customReport = action.payload || [];
            return;
        });
        builder.addCase(getCustomReport.fulfilled, (state, action) => {
            state.reportBuilder = action.payload || [];
            return;
        });
        builder.addCase(getCustomReportById.fulfilled, (state, action) => {
            state.editReport = action.payload || {};
            return;
        });
        builder.addCase(getLeadPerformanceReport.fulfilled, (state, action) => {
            state.leadPerformanceReport = action.payload || [];
            return;
        });
        builder.addCase(getMassImportLog.fulfilled, (state, action) => {
            state.massImportLog = action.payload || [];
            return;
        });

        builder.addCase(getReportDetails.fulfilled, (state, action) => {
            state.reportDetails = action.payload || [];
            return;
        });
    }
});

export const { removeEmployeeLead, removeReport } = reportSlice.actions;

export default reportSlice.reducer;
